export default __webpack_public_path__ + "static/landing-section-3-img-2-faee574a7fecd4b88c052daaa76aefd1.png";